document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector("ul.newmenu.newmenu-root.desktop-menu");

  // Add initial gap
  if (menu) {
    menu.classList.add("initial-gap");
  }

  // Remove gap once page fully loaded
  window.addEventListener("load", function () {
    if (menu) {
      setTimeout(() => {
        menu.classList.remove("initial-gap");
      }, 100); // small smooth delay
    }
  });
});
